import { axios } from '@/services/axios';

/**
 * Trunk types assignable to an SRT service profile at partner level.
 *
 * Mirrors the SBCaaS equivalent — the platform is in the path, so the list
 * comes back SRT-only. There is no wholesaler-level counterpart; that level
 * reads the platform-agnostic `/TrunkTypes/Available`.
 */
const getSRTTrunkTypesForServiceProfile = async (partnerId) => {
    const result = await axios.get(
        `/ServiceProfiles/SRT/Partner/${partnerId}/TrunkTypes/Available`,
    );
    return result;
};

export default getSRTTrunkTypesForServiceProfile;
